import React, { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ConfirmProvider } from './contexts/ConfirmContext';
import { Toaster } from './components/ui/sonner';
import HomePage from './pages/HomePage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/AdminDashboard';
import ResellerLogin from './pages/ResellerLogin';
import ResellerDashboard from './pages/ResellerDashboard';
import ResellerRankingPublic from './pages/ResellerRankingPublic';
import InscricaoAfiliado from './pages/InscricaoAfiliado';
import TopAfiliados from './pages/TopAfiliados';
import MegaPremioPublic from './pages/MegaPremioPublic';
import MeuHostPreferidoPublic from './pages/MeuHostPreferidoPublic';
import BatalhaDePKPublic from './pages/BatalhaDePKPublic';
import MysteryBoxEventPage from './pages/MysteryBoxEventPage';
import RoulettePage from './pages/RoulettePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CustomerAccount from './pages/CustomerAccount';
import FoxAgencyPage from './pages/FoxAgencyPage';
import OilTycoonPage from './pages/OilTycoonPage';
import WitchBalloonPage from './pages/WitchBalloonPage';
import RecargaPremiadaPage from './pages/RecargaPremiadaPage';
import GbArenaPage from './pages/GbArenaPage';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import { configAPI } from './services/api';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

function App() {
  const [pwaEnabled, setPwaEnabled] = useState(true);

  useEffect(() => {
    // Carregar configuração do PWA
    const loadConfig = async () => {
      try {
        const response = await configAPI.get();
        setPwaEnabled(response.data?.pwa_notification_enabled ?? true);
      } catch (error) {
        console.log('Config load error:', error);
      }
    };
    loadConfig();
  }, []);

  return (
    <AuthProvider>
      <ConfirmProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ranking-afiliados" element={<ResellerRankingPublic />} />
          <Route path="/top-afiliados" element={<TopAfiliados />} />
          <Route path="/mega-premio" element={<MegaPremioPublic />} />
          <Route path="/meu-host-preferido" element={<MeuHostPreferidoPublic />} />
          <Route path="/batalha-de-pk" element={<BatalhaDePKPublic />} />
          <Route path="/bau-misterioso" element={<MysteryBoxEventPage />} />
          <Route path="/roleta" element={<RoulettePage />} />
          <Route path="/inscricao-afiliado" element={<InscricaoAfiliado />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/conta" element={<CustomerAccount />} />
          <Route path="/foxagency" element={<FoxAgencyPage />} />
          <Route path="/tycoon" element={<OilTycoonPage />} />
          <Route path="/witch-balloon" element={<WitchBalloonPage />} />
          <Route path="/recarga-premiada" element={<RecargaPremiadaPage />} />
          <Route path="/arena" element={<GbArenaPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/reseller/login" element={<ResellerLogin />} />
          <Route path="/reseller/dashboard" element={<ResellerDashboard />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        <PWAInstallPrompt enabled={pwaEnabled} />
        <Toaster />
      </BrowserRouter>
      </ConfirmProvider>
    </AuthProvider>
  );
}

export default App;
